<template>
  <div class="policy-wrap" v-if="termsData !== null" ref="agreement-body">
    <div class="policy-date">시행일자 {{termsData.effectivedate}}</div>
    <div class="policy-desc" v-html="termsData.content"></div>
    <div class="policy-btn">
      <ul>
        <li v-if="termsData.prevversion !== ''" class="pre-policy">
          <a @click.prevent="getAgreementVersion(termsData.prevversion)" href="#">
            <img src="/img/common/arrow-title-prev.png" alt=""/>
            <span>이전 약관 보기</span>
          </a>
        </li>
        <li v-if="termsData.version !== 'last'" class="now-policy">
          <a @click.prevent="getAgreementVersion('last')" href="#">
            <span>현재 약관 보기</span>
            <img src="/img/common/arrow-title-next.png" alt=""/></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { AgreementService } from '@/common/api/api.service'
export default {
  name: 'CommonAgreement',
  components: {},
  data () {
    return {
      termsData: null,
      version: 'last'
    }
  },
  methods: {
    getType () {
      if (this.$route.name === 'paid') {
        return 'payment'
      } else if (this.$route.name === 'pooqzone_voucher'){
        return 'pooqzone'
      } else {
        return this.$route.name
      }
    },
    getAgreementVersion (termVersion) {
      this.version = termVersion
      this.setAgreementData()
    },
    setAgreementData () {
      AgreementService.getTerms({
        type: this.getType(),
        version: this.version
      }).then(({ data }) => {
        this.termsData = data
        this.$nextTick(() => {
          this.$refs['agreement-body'].scrollTo(0, 0)
        })
      })
    }
  },
  created () {
    this.setAgreementData()
  }
}
</script>

<style scoped>
 .policy-date{
   padding: 0 15px;
   height: 44px;
   line-height: 44px;
   font-size: 12px;
   color: #a5a5a5;
   border-bottom: 1px solid #2f2f2f;
 }
 .policy-desc {
   font-size: 13px;
   line-height: 22px;
   color: #a5a5a5;
   padding: 15px 15px 50px;
 }
 .policy-wrap {
   width: 100%;
   padding-bottom: 30px;
 }
 .policy-wrap::-webkit-scrollbar{
   display: none;
   background-color: transparent;
 }
 .policy-btn {
   padding-left: 10px;
 }
 .policy-btn a {
   display: block;
   width: 100%;
   height: 30px;
   padding: 0 12px;
   border-radius: 100px;
   border: 1px solid #d9d9d9;
   font-size: 0;
   line-height: 28px;
   text-align: center;
   color: #fff;
 }
 .policy-btn a img,
 .policy-btn a span{
   display: inline-block;
   font-size: 12px;
   vertical-align: middle;
 }
 .policy-btn a img{
   width: 12px;
   height: 12px;
 }
 .policy-btn a img + span,
 .policy-btn a span + img{
   margin-left: 3px;
 }
 .policy-btn ul::after{
   content: '';
   display: table;
   clear: both;
 }
 .policy-btn li {
   float: left;
   text-align: center;
 }

 .policy-btn li.now-policy{
   float: right;
 }
</style>
